import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_material_issue = async (issue) => {
  try {
    const data = {
      request: issue?.number,
      number: issue?.issue_number,
      date: issue?.date,
      issue_date: issue?.issue_date,
      details: issue?.details,
      subtotal: issue?.subtotal,
      taxamount: issue?.taxamount,
      total: issue?.total,
      status: issue?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/create-material-issue`,
      data,
      config,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const update_material_issue = async (issue) => {
  try {
    console.log("adknsa", issue)
    const data = {
      id: issue?.issue,
      request: issue?.number,
      number: issue?.issue_number,
      date: issue?.date,
      issue_date: issue?.issue_date,
      details: issue?.details,
      subtotal: issue?.subtotal,
      taxamount: issue?.taxamount,
      total: issue?.total,
      status: issue?.status,
    };

    const token = localStorage.getItem("user");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/update-material-issue`,
      data,
      config,
    );

    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_material_issue = async (issue) => {
  try {
    const data = {
      id: issue?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-material-issue`,
      data,
      config,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_material_issues = async (issue) => {
  try {
    const data = {
      search: issue?.search,
      sort: issue?.sort,
      status: issue?.status,
      date: issue?.date,
      page: issue?.page,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-material-issues`,
      data,
      config,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const delete_material_issue = async (issue) => {
  try {
    const data = {
      id: issue?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/delete-material-issue`,
      data,
      config,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_material_issue,
  update_material_issue,
  get_material_issue,
  get_all_material_issues,
  delete_material_issue,
};
